module.exports = __webpack_public_path__ + "static/media/8.75fc3c2b.jpg";